import { Router } from 'vue-router'
import useAppStore from '@/store/modules/app'
import config from '@/config'

// 路由守卫 权限
const createPermissionGuard = (router: Router) => {
    router.beforeEach(async (to, from, next) => {
        next()
    })
}

// 路由切换过程中产生的数据
const createPageGuard = (router: Router) => {
    router.afterEach((to) => {
        useAppStore().setCurrentRoute(to)
        document.title = to.meta.title ? to.meta.title + ' - ' + config.title : config.title
    })
}

export function setupRouterGuard(router: Router) {
    createPageGuard(router)
    createPermissionGuard(router)
}
